import {
  BackgroundWidth as HygraphBackgroundWidth,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { BackgroundWidth } from '@/enums/background-width';

export default function backgroundWidthTransformer(
  props: HygraphMaybe<HygraphBackgroundWidth> | undefined
) {
  switch (props) {
    case HygraphBackgroundWidth.ContentWide:
      return BackgroundWidth.CONTENT_WIDE;
    case HygraphBackgroundWidth.PageWide:
      return BackgroundWidth.PAGE_WIDE;
    default:
      return undefined;
  }
}
